import { type FunctionComponent, useCallback } from "react";

import type { ArticlesSearchFilterByDateRange } from "scmp-app/components/search/contexts";
import { useSearchContext } from "scmp-app/components/search/contexts";
import { DropdownMenu } from "scmp-app/components/search/search-result-panel/components/dropdown-menu";

import { getTimeRangeForDays } from "./helpers";

type Option = {
  text: string;
  value: ArticlesSearchFilterByDateRange;
};

type Props = {
  className?: string;
};

export const DateRangeMenu: FunctionComponent<Props> = ({ className }) => {
  const { dateRange, setDateRange, setDateRangeText } = useSearchContext();
  const isChangedOptionColor = dateRange && Object.keys(dateRange).length > 0;

  const dateRangeOptions: Option[] = [
    {
      text: "Past 24 Hours",
      value: getTimeRangeForDays(1),
    },
    {
      text: "7 Days",
      value: getTimeRangeForDays(7),
    },
    {
      text: "60 Days",
      value: getTimeRangeForDays(60),
    },
    {
      text: "12 Months",
      value: getTimeRangeForDays(365),
    },
    {
      text: "All",
      value: {},
    },
  ];

  const handleOptionSelect = useCallback(
    (selected: Option) => {
      setDateRange?.({ ...selected.value });
      setDateRangeText?.(selected.text);
    },
    [setDateRange, setDateRangeText],
  );

  return (
    <DropdownMenu
      className={className}
      isChangedOptionColor={isChangedOptionColor}
      onOptionSelect={handleOptionSelect}
      options={dateRangeOptions}
      placeholder="Date Range"
      selectedOptionValue={dateRange}
    />
  );
};

DateRangeMenu.displayName = "DateRangeMenu";
